/**
 * Title panel for the Jobs list page.
 */
import {TargetBlank} from '@wandb/weave/common/util/links';
// @todo: Migrate to @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components/Button';
import {TailwindContents} from '@wandb/weave/components/Tailwind';
import React from 'react';

import DocUrls from '../../../util/doc_urls';

export const JobsHeader: React.FC<{}> = () => {
  return (
    <TailwindContents>
      <div className="flex align-center mb-16 p-4">
        <div className="font-semibold text-2xl leading-8">Jobs</div>
        <div className="flex-1" />
        <TargetBlank href={DocUrls.launchJobsCreate}>
          <Button size="large" variant="secondary" icon="documentation">
            Documentation
          </Button>
        </TargetBlank>
      </div>
    </TailwindContents>
  );
};
